module.exports = __webpack_public_path__ + "static/media/will.a657eb18.jpeg";